import React from "react";
import "./Project.css";

import fizodark from "../../Photos/Project-Photos/fizo-dark.png";
import fizolight from "../../Photos/Project-Photos/fizo-light.png";

import fictionallight from "../../Photos/Project-Photos/fictionallight.png";
import fictionaldark from "../../Photos/Project-Photos/fictionaldark.png";

import notedark from "../../Photos/Project-Photos/notedark.png";
import notelight from "../../Photos/Project-Photos/notelight.png";

import f4flight from "../../Photos/Project-Photos/f4flight.png";
import f4fdark from "../../Photos/Project-Photos/f4fdark.png";

import darkUnity from "../../Photos/Project-Photos/darkUnity.png";
import lightUnity from "../../Photos/Project-Photos/lightUnity.png";

import brain from "../../Photos/Project-Photos/B.R.A.I.N.png";
import pao from "../../Photos/Project-Photos/PAOFashionz.png";

function Project({ darkMode }) {
    const projects = [
        {
            title: "PAO Fashionz",
            image: pao,
            description:
                "Collaborated in a team to create a branded and dynamic online storefront featuring storytelling, a gallery, and seamless shopping experiences.",
            stack: [
                "DynamoDB",
                "Next.js",
                "Typescript",
                "Tailwind CSS",
                "Shopify Storefront API",
                "Vercel",
                "Sanity CMS",
            ],
            link: "https://www.paofashionz.ca/",
        },
        {
            title: "B.R.A.I.N",
            image: brain,
            description:
                "AI-powered flashcard and competitive learning platform designed to improve retention through adaptive study sessions, spaced repetition, and multiplayer educational battles.",
            stack: ["React", "AWS", "DynamoDB"],
            link: "https://b-r-a-i-n.vercel.app/",
        },

        {
            title: "UNI-TY",
            image: darkMode ? darkUnity : lightUnity,
            description:
                "Resource-sharing platform built for University of Calgary students to improve access to academic materials and collaborative learning resources.",
            stack: ["Next.js",
"Typescript"
,"Tailwind CSS"
,"Firebase"
,"Firestore"
,"Selenium"
,"Vercel"],
            link: "https://uni-ty-fawn.vercel.app/",
        },

        {
            title: "Fight4Flight",
            image: darkMode ? f4fdark : f4flight,
            description:
                "Full-stack airline booking platform supporting account management, ticket generation, and flight reservation workflows.",
            stack: ["React", "SQL", "Spring Boot", "Java"],
            link: "https://github.com/fisayoadabs/fight4flight",
        },

        {
            title: "Fictional Legacy Compiler",
            image: darkMode ? fictionaldark : fictionallight,
            description:
                "Cloud-based obituary generator powered by AWS Lambda workflows, Terraform infrastructure, Cloudinary uploads, and OpenAI integrations.",
            stack: ["AWS", "Terraform", "OpenAI", "React"],
            link: "https://ornate-basbousa-0f9dfa.netlify.app/",
        },

        {
            title: "Note Taking Application",
            image: darkMode ? notedark : notelight,
            description:
                "Secure cloud-connected note management application with Google authentication and full CRUD functionality.",
            stack: ["React", "AWS", "Terraform", "Google OAuth"],
            link: "https://sweet-biscuit-632102.netlify.app/",
        },

        {
            title: "FIZO Word Game",
            image: darkMode ? fizodark : fizolight,
            description:
                "Word guessing game inspired by Wordle featuring multiple gameplay modes, dark mode, and AWS-backed API integrations.",
            stack: ["JavaScript", "AWS", "HTML/CSS"],
            link: "https://fisayoadabs.github.io/Fizo_Game/",
        },
    ];

    return (
        <section
            className={`projects-section ${darkMode ? "dark" : ""}`}
            id="project"
        >
            <div className="projects-container">
                <span className="projects-tag">FEATURED WORK</span>

                <h1>Projects</h1>

                <div className="projects-grid">
                    {projects.map((project, index) => (
                        <div
                            className={`project-card ${project.featured ? "featured" : ""}`}
                            key={index}
                        >
                            <div className="project-image-wrapper">
                                <img src={project.image} alt={project.title} />
                            </div>

                            <div className="project-content">
                                <div className="project-header">
                                    <h2>{project.title}</h2>

                                    {project.featured && (
                                        <span className="featured-badge">
                                            Featured
                                        </span>
                                    )}
                                </div>

                                <p>{project.description}</p>

                                <div className="project-stack">
                                    {project.stack.map((tech, idx) => (
                                        <span key={idx}>{tech}</span>
                                    ))}
                                </div>

                                <a
                                    href={project.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="project-link"
                                >
                                    View Project →
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Project;